import { createContext, useContext } from 'react';
import { useOutletContext } from 'react-router-dom';

// A TabbedPage provides its own setter here so a tab's breadcrumb controls can be merged with the
// page-level buttons the TabbedPage shows itself. Outside a TabbedPage it falls back to the layout's setter.
export const TabActionsContext = createContext(null);

export function useCrumbActionsSetter() {
    const fromTabs = useContext(TabActionsContext);
    const outlet = useOutletContext() || {};
    return fromTabs || outlet.setCrumbActions;
}
